import DataSource from "../DataSource/DataSource";

export default class ForecastRulesService {
  constructor(server) {
    this.server = server;
  }
  // month rules
  listMonthRules() {
    return this.server("forecast.rules.month.list", {});
  }
  listMonthUpdateRules(parentId) {
    return this.server("forecast.rules.update.list", { parentId });
  }
  saveMonthRule(monthRule, id, force) {
    if (typeof force!=='undefined' && force){
      monthRule.force = '1';
    }
    return this.server("forecast.rules.month.save", {
      data: monthRule,
      id: id
    });
  }
  getMonthRule(id) {
    return this.server("forecast.rules.month.get", { id: id });
  }
  getMonthUpdateRule(id) {
    return this.server("forecast.rules.update.get", { id: id });
  }
  deleteMonthRule(id) {
    return this.server("forecast.rules.month.delete", { id: id });
  }

  // update rule
  saveUpdateRule(updateRule, id, parentId, force) {
    if (typeof force !== 'undefined' && force){
      updateRule.force = '1';
    }
    return this.server("forecast.rules.update.save", {
      data: updateRule,
      id: id,
      parentId: parentId
    });
  }

  deleteUpdateRule(id) {
    return this.server("forecast.rules.update.delete", { id: id });
  }

  // generic
  listOPMs(type, id) {
    return this.server("forecast.rules.listopms", { type, id });
  }

  loadStatuses(){
    return this.server('forecast.rules.liststatuses', {});
  }
}



// WEBPACK FOOTER //
// ./src/ForecastRules/ForecastRulesService.js